import { AppBar, Box, Stack, Toolbar } from '@mui/material';
import SweepLogoSmall from './icons/SweepLogoSmall.svg?react';
import UserMenu from './UserMenu';
import PaywallDashboardHeader from './PaywallDashboardHeader';
import useSweepNavigate from '../../../navigation-utils/useSweepNavigate';
import { DEFAULT_ROUTE } from '../../../constants/appRoutes';
import HeaderDivider from './HeaderDivider';
import { EnvSelector } from '../../pages/environments/connect-env/EnvSelector';
import { HeaderButton } from './HeaderButton';
import { colors } from '@sweep-io/sweep-design';
import { DASHBOARD_HEADER_HEIGHT_PX, DASHBOARD_HEADER_PADDING_RIGHT } from '../../../constants';
import { useMenuItemsWithPermissions } from './useMenuItemsWithPermissions';
import { handleNavigationWithModifiers } from './utils/navigationUtils';

const DashboardHeader = () => {
  const { navigate } = useSweepNavigate();
  const mainMenuItems = useMenuItemsWithPermissions();

  return (
    <AppBar
      sx={{
        zIndex: 1300,
        p: `0px ${DASHBOARD_HEADER_PADDING_RIGHT} 0px 32px`,
        minHeight: DASHBOARD_HEADER_HEIGHT_PX,
        borderBottom: `1px solid ${colors.grey[300]}`,
        background: colors.white,
        boxShadow: 'none',
      }}
      position="sticky"
    >
      <Toolbar
        variant="dense"
        sx={{
          p: '0px !important',
          justifyContent: 'space-between',
          boxShadow: 'none',
          minHeight: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 1,
            height: '100%',
          }}
        >
          <Stack
            onClick={(event) =>
              handleNavigationWithModifiers(event, DEFAULT_ROUTE, () => navigate(DEFAULT_ROUTE))
            }
            sx={{ cursor: 'pointer', alignItems: 'center', pr: 2 }}
          >
            <SweepLogoSmall />
          </Stack>
          <HeaderDivider color={colors.grey[300]} />

          {mainMenuItems.map((item) =>
            item.isHidden ? null : (
              <HeaderButton
                key={item.label}
                label={item.label}
                Icon={item.Icon}
                route={item.route}
                menuColumns={item.menuColumns}
                onClick={() => navigate(item.route)}
              />
            ),
          )}
        </Box>

        <Box display="flex" gap={1.5} pl={2} alignItems="center">
          <EnvSelector />
          <PaywallDashboardHeader />
          <UserMenu />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default DashboardHeader;
